// import { Search } from "lucide-react";
// import DateInput from "./shared/DateInput.jsx";

// export default function AttendanceFilters({
//   perPage, setPerPage,
//   dateFrom, setDateFrom,
//   dateTo, setDateTo,
//   statusFilter, setStatusFilter,
//   rangeFilter, setRangeFilter,
//   sortBy, setSortBy,
//   searchRaw, setSearchRaw,
//   onFilterChange,   // called whenever any filter changes to reset page
// }) {
//   const handle = (setter) => (val) => {
//     setter(val);
//     onFilterChange();
//   };

//   return (
//     <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
//       {/* Per-page */}
//       <div className="flex items-center gap-2 text-sm">
//         <span className="dark:text-white">Row Per Page</span>
//         <select
//           value={perPage}
//           onChange={(e) => handle(setPerPage)(+e.target.value)}
//           className="rounded-lg border px-2 py-1 dark:border-white/10 dark:bg-navy-800 dark:text-white"
//         >
//           {[10, 20, 50].map((n) => <option key={n} value={n}>{n}</option>)}
//         </select>
//         <span className="text-gray-500">Entries</span>
//       </div>

//       {/* Right-side controls */}
//       <div className="flex flex-wrap items-center gap-2 dark:text-white">
//         <DateInput value={dateFrom} onChange={handle(setDateFrom)} />
//         <span className="text-gray-500">–</span>
//         <DateInput value={dateTo}   onChange={handle(setDateTo)} />

//         <select
//           value={statusFilter}
//           onChange={(e) => handle(setStatusFilter)(e.target.value)}
//           className="rounded-lg border px-3 py-2 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
//         >
//           <option>All</option>
//           <option>Present</option>
//           <option>Absent</option>
//           <option>Leave</option>
//         </select>

//         <select
//           value={rangeFilter}
//           onChange={(e) => handle(setRangeFilter)(e.target.value)}
//           className="rounded-lg border px-3 py-2 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
//         >
//           <option>All</option>
//           <option>In Office</option>
//           <option>Nearby</option>
//           <option>Moderate</option>
//           <option>Far</option>
//           <option>No GPS</option>
//         </select>

//         <select
//           value={sortBy}
//           onChange={(e) => handle(setSortBy)(e.target.value)}
//           className="rounded-lg border px-3 py-2 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
//         >
//           <option value="last7">Sort By : Last 7 Days</option>
//           <option value="last30">Sort By : Last 30 Days</option>
//           <option value="all">Sort By : All</option>
//         </select>

//         <div className="relative">
//           <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400 dark:text-white" />
//           <input
//             type="text"
//             placeholder="Search"
//             value={searchRaw}
//             onChange={(e) => { setSearchRaw(e.target.value); onFilterChange(); }}
//             className="w-56 rounded-lg border py-2 pl-9 pr-3 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
//           />
//         </div>
//       </div>
//     </div>
//   );
// }

// src/views/hrms/attendance/components/AttendanceFilters.jsx
import { Search } from "lucide-react";
import DateInput from "./shared/DateInput.jsx";

export default function AttendanceFilters({
  perPage,      setPerPage,
  dateFrom,     setDateFrom,
  dateTo,       setDateTo,
  statusFilter, setStatusFilter,
  rangeFilter,  setRangeFilter,
  sortBy,       setSortBy,
  searchRaw,    setSearchRaw,
  onFilterChange,
}) {
  const handle = (setter) => (val) => {
    setter(val);
    onFilterChange();
  };

  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
      {/* Per-page */}
      <div className="flex items-center gap-2 text-sm">
        <span className="dark:text-white">Row Per Page</span>
        <select
          value={perPage}
          onChange={(e) => handle(setPerPage)(+e.target.value)}
          className="rounded-lg border px-2 py-1 dark:border-white/10 dark:bg-navy-800 dark:text-white"
        >
          {[10, 20, 50].map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
        <span className="text-gray-500">Entries</span>
      </div>

      {/* Right-side controls */}
      <div className="flex flex-wrap items-center gap-2 dark:text-white">
        <DateInput value={dateFrom} onChange={handle(setDateFrom)} />
        <span className="text-gray-500">–</span>
        <DateInput value={dateTo}   onChange={handle(setDateTo)} />

        {/* Status filter — now includes all statuses */}
        <select
          value={statusFilter}
          onChange={(e) => handle(setStatusFilter)(e.target.value)}
          className="rounded-lg border px-3 py-2 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
        >
          <option value="All">All Status</option>
          <option value="Present">Present</option>
          <option value="HalfDay">Half Day</option>
          <option value="Late">Late</option>
          <option value="Absent">Absent</option>
          <option value="WeeklyOff">Weekly Off</option>
          <option value="Holiday">Holiday</option>
          <option value="Leave">Leave</option>
        </select>

        <select
          value={rangeFilter}
          onChange={(e) => handle(setRangeFilter)(e.target.value)}
          className="rounded-lg border px-3 py-2 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
        >
          <option value="All">All Range</option>
          <option>In Office</option>
          <option>Nearby</option>
          <option>Moderate</option>
          <option>Far</option>
          <option>No GPS</option>
        </select>

        <select
          value={sortBy}
          onChange={(e) => handle(setSortBy)(e.target.value)}
          className="rounded-lg border px-3 py-2 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
        >
          <option value="last7">Last 7 Days</option>
          <option value="last30">Last 30 Days</option>
          <option value="all">All</option>
        </select>

        <div className="relative">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400 dark:text-white" />
          <input
            type="text"
            placeholder="Search employee"
            value={searchRaw}
            onChange={(e) => { setSearchRaw(e.target.value); onFilterChange(); }}
            className="w-56 rounded-lg border py-2 pl-9 pr-3 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
          />
        </div>
      </div>
    </div>
  );
}